import { Component, OnInit } from '@angular/core';
import { Widget, Dashboard } from 'src/api/models'
import { IWidgetEditor, WidgetType, TimeSeriesDetail, WindRoseWidget } from "src/app/models/dashboard";

@Component({
  selector: 'app-wind-rose-widget-editor',
  templateUrl: './wind-rose-widget-editor.component.html',
  styleUrls: ['./wind-rose-widget-editor.component.css']
})
export class WindRoseWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: WindRoseWidget;
  public dashboard: Dashboard;
  public w: any;

  public primaryActive: TimeSeriesDetail;
  public secondaryActive: TimeSeriesDetail;

  private _disabledV: string = '0';
  private disabled: boolean = false;

  private get disabledV(): string {
    return this._disabledV;
  }

  private set disabledV(value: string) {
    this._disabledV = value;
    this.disabled = this._disabledV === '1';
  }

  constructor() { 
    this.primaryActive = {uri:null,transforms:null,sourceType:null,tagMatches:null,type:null,forceEmbed:false} as TimeSeriesDetail;
    this.secondaryActive = {uri:null,transforms:null,sourceType:null,tagMatches:null,type:null,forceEmbed:false} as TimeSeriesDetail;
  }

  ngOnInit() {
    this.w = <WindRoseWidget>this.widget;

    if (this.w == null){
      this.w = {} as WindRoseWidget;
    }
    if (this.w.timeSeriesList == null || this.w.timeSeriesList.length != 2) {
      this.w.timeSeriesList = [{}, {}];
    } else if (this.w?.timeSeriesList?.length === 2) {
      this.primaryActive = this.w.timeSeriesList[0];
      this.secondaryActive = this.w.timeSeriesList[1];
    }
  }

  public selectedInput(uri: any, index: number): void {
    this.w.timeSeriesList[index].uri = uri;
  }
}
